// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__8vlhw","name":"Header_name__1x3H2","birthday":"Header_birthday__2Xs2H","skeleton":"Header_skeleton__3qzYV"};